import { CREATE_MODE, POST_PONE_MODE } from '@agent/core/contact/appointment/popup/appointment-popup.component';
import { ISortByNameAndOrder, REFRESH_INPROCESS_INTERACTIONS } from '@agent/core/contact/history/models/history-models';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { HttpDeprecatedService } from '@commons/core/transport/http-deprecated.service';
import {
  Appointment,
  IAppointment,
  IAppointmentDto,
  IVisioAppointment,
  IVisioAppointmentDetail,
  IVisioAppointmentDetailLight,
  VisioAppointmentDetail,
} from '@commons/models/appointment';
import { CampaignLiteDto, CampaignUtil } from '@commons/models/campaign';
import { PostContactReportDto } from '@commons/models/post-contact-report';
import { TimeSlotUtil } from '@commons/models/time-slot';
import { RxUtil } from '@commons/util/utilities/rx';
import { IHttpService, ILogService, IPromise, IQService, isArray } from 'angular';
import moment from 'moment';
import { filter, map, Observable, tap } from 'rxjs';

import {
  APPOINTMENT_FACADE_PREFIX,
  Campaign,
  CampaignDto,
  CampaignType,
  CCXMLTimeSlotDto,
  ChanEnum,
  Channel,
  Configuration,
  CSR_FACADE_PREFIX,
  InterviewType,
  MessagingService,
  None,
  Option,
  randomUUID,
  Skill,
  TimeSlot,
} from '@contact/upgrade';

const SEARCH_CAMPAIGN_CONTACTS_BY_ADDRESS_URL_OR_COMPANYNAME = 'protected/search/getCampaignContactsByAddressOrCompanyName';
const SEARCH_CAMPAIGN_CONTACTS_BY_ADDRESS_URL = 'protected/search/getCampaignContactsByAddress';
const GET_APPOINTMENT = '/protected/appointment/';

/**
 * correspond to contactStatus from campaign
 */
export enum AppointmentQualificationStatus {
  SUCCESS,
  CANCELED,
}

/**
 * format of data pass through appointment popin
 */
export interface ModalParamAppointment {
  idAppointment?: string;
  responseId?: string;
  contactId?: string;
  contactUri?: string;
  contactFirstName?: string;
  contactLastName?: string;
  skillsToPreselect?: string[];
  mode: string;
  appointment?: IVisioAppointment;
}

/**
 * format of params passed to appointment rescheduling popup
 */
export interface ModalParamAppointmentRescheduling {
  appointmentId: string;
  campaignId: string;
  originalTimeSlot: TimeSlot;
}

/**
 * @deprecated
 */
export interface IAppointmentDeprecatedService {
  mandatoryComment: number;

  /**
   * used to open a popin in which agent can create an appointment
   * parameters are used to pre fill fields
   * @param {string} [responseId]
   * @param {string} [contactUri]
   * @param {string} [contactFirstName]
   * @param {string} [contactLastName]
   * @param {string[]} [skillsToPreselect]
   * @deprecated
   */
  openAppointmentForm(
    responseId?: string,
    contactUri?: string,
    contactFirstName?: string,
    contactLastName?: string,
    skillsToPreselect?: string[]
  ): void;

  /**
   * used to open a popup in which a new time slot can be choosed for given appointment
   * @param appointment the appointment to update
   * @deprecated
   */
  openPostPoneAppointmentForm(appointment: IAppointment): Observable<void>;

  /**
   * @param responseId
   * @param contactUri
   * @param contactFirstName
   * @param contactLastName
   * @param skillsToPreselec
   * @deprecated
   */
  openAppointmentFormForContact(
    contactId?: string,
    contactUri?: string,
    contactFirstName?: string,
    contactLastName?: string,
    skillsToPreselect?: string[]
  ): void;

  /**
   * used to open a popin in which agent can transfer an appointment
   * parameters are used to pre fill fields
   * @param {idAppointment} [string]
   * @param {string[]} [skillsToPreselect]
   */
  openAppointmentTransferForm(idAppointment: string, skillsToPreselect?: string[], interviewType?: InterviewType): Observable<void>;

  /**
   * retrieve currently existing appointment for the given uuid
   * @param {string} idAppointment
   * @returns {Observable<IVisioAppointmentDetailLight>}
   */
  getAppointment(idAppointment: string): Observable<IVisioAppointmentDetailLight>;

  /**
   * transfer the existing appointment
   * @param {IVisioAppointmentDetail} appointment
   * @returns {IPromise<any>}
   */
  transferAppointment(appointment: IVisioAppointmentDetail): IPromise<any>;

  /**
   * used to open the popup for rescheduling the appointment
   * @param appointmentId: the id of the appointment
   * @param campaignId: the campaign id of the appointment
   * @param originalTimeSlot: the original time slot of the appointment
   */
  openAppointmentReschedulingForm(appointmentId: string, campaignId: string, originalTimeSlot: TimeSlot): void;

  /**
   * used to instanciate an appointment with no data to prefill
   * @returns {IPromise<IAppointment>}
   * @deprecated
   */
  buildEmptyAppointment(): IPromise<IAppointment>;

  /**
   * used to instanciate an appointment with no data to prefill
   * we retrieve skill list in order to prefill skills, and contact uri
   * @param contactUriToUse
   * @param contactFirstNameToUse
   * @param contactLastNameToUse
   * @param skillsToPreselect
   * @deprecated
   */
  buildAppointment(
    contactUriToUse: Option<string>,
    contactFirstNameToUse: Option<string>,
    contactLastNameToUse: Option<string>,
    skillsToPreselect: Option<string[]>
  ): IPromise<IAppointment>;

  /**
   * send given appointment to campaign service
   * @param {IAppointment} appointment
   * @returns {IPromise<any>}
   * @deprecated
   */
  createAppointment(appointment: IAppointment): IPromise<any>;

  /**
   * retrieve campaign callback appointment(Campaign contact) with given contact id
   * @param {string} contactId
   * @returns {Observable<IAppointment>}
   * @deprecated
   */
  getCampaignContactById(contactId: string): Observable<IAppointment>;

  /**
   * retrieve currently existing appointment for given contact uri
   * @param {string} contactUri
   * @returns {IPromise<IAppointment[]>}
   * @deprecated
   */
  getAppointments(contactUri: string, contactCompanyName: string): Observable<IAppointment[]>;

  /**
   * @deprecated
   */
  deleteAppointment(appointment: IAppointment): IPromise<any>;

  /**
   * Change the appointment of a contact of a scheduled campaign. The given appointment is the new one.
   * The contact MUST already be known by the campaign of this appointment.
   * @param {IAppointment} Target appointment
   * @returns {IPromise<IContact>}
   * @deprecated
   */
  changeAppointment(appointment: IAppointment): IPromise<any>;

  /**
   * retrieve skills available for appointment creation
   * @returns {IPromise<ISkill[]>}
   * @deprecated
   */
  getSkills(): IPromise<Skill[]>;

  /**
   * retrieve visio skills available for appointment creation/transfer
   * @returns {IPromise<ISkill[]>}
   * @deprecated
   */
  getVisioSkills(): IPromise<Skill[]>;

  /**
   * retrieve current existing schedule callback campaigns with their time slots
   * @returns {IPromise<Campaign[]>}
   * @deprecated
   */
  getCampaigns(): IPromise<Campaign[]>;

  /**
   * get Campaign by id
   * @param campaignId
   */
  getCampaignById(campaignId: string): IPromise<any>;

  /**
   * retrieve current existing schedule callback campaigns with their time slots
   * @returns {IPromise<Campaign[]>}
   * @deprecated
   */
  getAllScheduleCampaigns(): IPromise<Campaign[]>;

  getCampaignsByDomain(): IPromise<Campaign[]>;

  /**
   * retrieve available rechedule time for given campaign id and given day
   * @param {string} campaignId
   * @param {Date} day
   * @returns {number[]} list if time (millis since midnight for given day)
   * @deprecated
   */
  retrieveRescheduleTimesForDay(campaignId: string, day: Date): IPromise<number[]>;

  /**
   * retrieve current existing campaign with its time slots
   * @returns {IPromise<Campaign>}
   * @deprecated
   */
  getCampaign(campaignUuid: string): Observable<Campaign>;

  /**
   * retrieve current existing campaign with its opened time slots
   * @returns {IPromise<Campaign>}
   * @deprecated
   */
  getCampaignInfoWithOpenedTimeSlots(campaignUuid: string, endDate: Date | undefined): Observable<Campaign>;

  /**
   * @deprecated
   */
  getOpenedTimeSlots(campaignUuid: string, endDate: Date | undefined): IPromise<TimeSlot[]>;

  /**
   * used to close an appointment
   * @param report the report to send to campaign
   * @deprecated
   */
  closeAppointment(report: PostContactReportDto): IPromise<any>;

  /**
   * used to search an appointment when elastic search needed
   * @param contactId
   * @deprecated
   */
  searchAppointmentsByContact(contactId: string): Observable<IVisioAppointmentDetail[]>;

  /**
   * @deprecated
   */
  searchAppointmentsByContact(contactId: string, from: number, to: number): Observable<IVisioAppointmentDetail[]>;

  /**
   * @deprecated
   */
  searchAppointmentsByContact(
    contactId: string,
    from: number,
    to: number,
    sort: ISortByNameAndOrder[]
  ): Observable<IVisioAppointmentDetail[]>;

  /**
   * @deprecated
   */
  searchAppointmentsById(appointmentId: string): Observable<IVisioAppointmentDetail[]>;

  /**
   * @deprecated
   */
  searchAppointmentsById(
    appointmentId: string,
    from: number,
    to: number,
    sort: ISortByNameAndOrder[]
  ): Observable<IVisioAppointmentDetail[]>;
}

/**
 * appointment service implementation
 * @implements {IAppointmentService}
 * @deprecated
 */
export class AppointmentDeprecatedService implements IAppointmentDeprecatedService {
  static $inject: Array<string> = [
    '$q',
    '$log',
    '$uibModal',
    '$filter',
    '$http',
    'httpDeprecated',
    'configuration',
    'messaging',
    'sessionDeprecatedService',
  ];
  mandatoryComment = 1;
  /**
   * contains available skills used to avoid request at each time popipn is opened
   * @type {ISkill[]}
   */
  availableSkills: Skill[];

  DEFAULT_SORT: ISortByNameAndOrder[] = [
    {
      name: 'startDate',
      order: 'desc',
    },
  ];

  /**
   * Creates an instance of AppointmentService.
   * @param {ILogService} $log
   * @param {IQService} $q
   * @param {*} $uibModal
   * @param {*} $filter
   * @param {*} $http
   * @param {*} $i18next
   * @param {HttpDeprecatedService} http
   * @param {IContactService} contact
   * @param {*} configuration
   */
  constructor(
    private readonly $q: IQService,
    private readonly $log: ILogService,
    private readonly $uibModal: any,
    private readonly $filter: any,
    private readonly $http: IHttpService,
    private readonly httpDeprecated: HttpDeprecatedService,
    private readonly configuration: Configuration,
    private readonly messaging: MessagingService,
    private readonly sessionDeprecatedService: SessionDeprecatedService
  ) {
    if (this.configuration.isMandatoryComment !== null && !isNaN(Number(this.configuration.isMandatoryComment))) {
      this.mandatoryComment = Number(this.configuration.isMandatoryComment);
    }
  }

  getSkills(): IPromise<Skill[]> {
    return this.getSkillsForChannel(ChanEnum.Out.Phone);
  }

  getVisioSkills(): IPromise<Skill[]> {
    return this.getSkillsForChannel(ChanEnum.Out.Visio);
  }

  getCampaigns(): IPromise<Campaign[]> {
    let deferred = this.$q.defer<Campaign[]>();

    this.$http
      .get(
        this.configuration.campaignBaseUrl +
          '/protected/campaign/getScheduleCampaignsByDomains?domainUuidList=' +
          this.sessionDeprecatedService.getProfile().domainId
      )
      .then(
        success => {
          if (success.data && isArray(success.data)) {
            deferred.resolve(
              this.$filter('orderBy')(success.data, 'name', false).map(
                (campaignDto: CampaignDto): Campaign => CampaignUtil.fromDto(campaignDto, this.$filter)
              )
            );
          } else {
            deferred.reject();
          }
        },
        () => {
          deferred.reject();
        }
      );

    return deferred.promise;
  }

  getCampaignById(campaignId: string): IPromise<any> {
    const deferred = this.$q.defer<any>();
    this.$http.get(this.configuration.campaignBaseUrl + '/protected/campaign/' + campaignId).then(
      success => {
        deferred.resolve(success);
      },
      () => {
        deferred.reject();
      }
    );
    return deferred.promise;
  }

  getAllScheduleCampaigns(): IPromise<Campaign[]> {
    let deferred = this.$q.defer<Campaign[]>();

    this.$http
      .get(
        this.configuration.campaignBaseUrl +
          '/protected/campaign/getScheduleVisioCampaignsByDomains?domainUuidList=' +
          this.sessionDeprecatedService.getProfile().domainId
      )
      .then(
        success => {
          if (success.data && isArray(success.data)) {
            deferred.resolve(
              this.$filter('orderBy')(success.data, 'name', false).map(
                (campaignDto: CampaignDto): Campaign => CampaignUtil.fromDto(campaignDto, this.$filter)
              )
            );
          } else {
            deferred.reject();
          }
        },
        () => {
          deferred.reject();
        }
      );

    return deferred.promise;
  }

  getCampaignsByDomain(): IPromise<Campaign[]> {
    const deferred = this.$q.defer<Campaign[]>();
    this.$http
      .get<CampaignLiteDto[]>(
        `${this.configuration.campaignBaseUrl}/protected/campaign/getCampaignsByDomain?domainUuid=` +
          this.sessionDeprecatedService.getProfile().domainId
      )
      .then(
        success => {
          if (success.data && Array.isArray(success.data)) {
            const campaigns = success.data.map((campaignDto: CampaignLiteDto) => CampaignUtil.fromDtoLite(campaignDto));
            deferred.resolve(this.$filter('orderBy')(campaigns, 'name', false));
          } else {
            deferred.reject();
          }
        },
        () => {
          deferred.reject();
        }
      );
    return deferred.promise;
  }

  getCampaign(campaignUUid: string): Observable<Campaign> {
    return RxUtil.fromPromise(() => this.$http.get(this.configuration.campaignBaseUrl + '/protected/campaign/' + campaignUUid)).pipe(
      filter((data: any) => data.data),
      map(value => CampaignUtil.fromDto(value.data, this.$filter))
    );
  }

  getCampaignInfoWithOpenedTimeSlots(campaignUuid: string, endDate: Date | undefined): Observable<Campaign> {
    let aBeginDate = moment().format('YYYY-MM-DDTHH:mm:ss').replace(/\:/g, '%3A');
    let anEndDate = endDate
      ? moment(endDate).format('YYYY-MM-DD') + 'T23%3A59%3A00'
      : moment().add(1, 'M').format('YYYY-MM-DD') + 'T23%3A59%3A00';
    return RxUtil.fromPromise(() =>
      this.$http.get(
        this.configuration.campaignBaseUrl +
          '/protected/campaign/infoWithTimeslots/' +
          campaignUuid +
          '?begin=' +
          aBeginDate +
          '&end=' +
          anEndDate +
          '&override=true'
      )
    ).pipe(
      filter((data: any) => data.data),
      map(value => CampaignUtil.fromDto(value.data, this.$filter))
    );
  }

  createAppointment(appointment: IAppointment | IVisioAppointment): IPromise<any> {
    if (appointment.campaign.type === CampaignType[CampaignType.VISIO_SCHEDULED_CALL_BACK]) {
      const currentCsr = this.sessionDeprecatedService.getProfile();
      return this.$http
        .post(
          this.configuration.campaignBaseUrl + '/protected/appointment/contact',
          VisioAppointmentDetail.toVisioCreationDto(appointment as IVisioAppointment, currentCsr)
        )
        .then(() => {
          // send the event
          this.messaging.forLocal().publish(REFRESH_INPROCESS_INTERACTIONS, undefined);
        });
    }
    return this.$http.post(this.configuration.campaignBaseUrl + '/protected/contact/manage', Appointment.toDto(appointment)).then(() => {
      // send the event
      this.httpDeprecated
        .asPromise()
        .withData(Appointment.toDtoForTrace(appointment, 'CREATED', 'CSR_BANNER', []))
        .post(CSR_FACADE_PREFIX + '/addTraceUpdatedAppointment')
        .then(() => {
          this.messaging.forLocal().publish(REFRESH_INPROCESS_INTERACTIONS, undefined);
          return;
        });
    });
  }

  transferAppointment(appointment: IVisioAppointmentDetail): IPromise<any> {
    return this.$http
      .post(
        `${this.configuration.campaignBaseUrl}/${APPOINTMENT_FACADE_PREFIX}/transfer`,
        VisioAppointmentDetail.toVisioTransferDto(appointment)
      )
      .then(() => {
        // send the event
        this.messaging.forLocal().publish(REFRESH_INPROCESS_INTERACTIONS, undefined);
      });
  }

  getAppointment(idAppointment: string): Observable<IVisioAppointmentDetailLight> {
    return RxUtil.fromPromise(() => this.$http.get(this.configuration.campaignBaseUrl + GET_APPOINTMENT + idAppointment)).pipe(
      filter((data: any) => data.data),
      map(value => VisioAppointmentDetail.fromDtoToLight(value.data))
    );
  }

  getCampaignContactById(contactId: string): Observable<IAppointment> {
    return RxUtil.fromPromise(() => this.$http.get(`${this.configuration.campaignBaseUrl}/protected/contact/${contactId}`)).pipe(
      filter(response => !!response.data),
      map(response => response.data as IAppointment)
    );
  }

  getAppointments(contactUri: string, contactCompanyName: string): Observable<IAppointment[]> {
    const SEARCH_PATH = contactCompanyName
      ? SEARCH_CAMPAIGN_CONTACTS_BY_ADDRESS_URL_OR_COMPANYNAME
      : SEARCH_CAMPAIGN_CONTACTS_BY_ADDRESS_URL;
    let deferred = this.$q.defer<IAppointment[]>();
    this.httpDeprecated
      .asPromise()
      .get(SEARCH_PATH, [encodeURIComponent(contactUri), contactCompanyName])
      .then(
        response => {
          if (response && response.data && isArray(response.data)) {
            deferred.resolve(
              this.$filter('filter')(
                response.data,
                (elem: IAppointmentDto) =>
                  elem.campaignType === CampaignType[CampaignType.CALLBACK] ||
                  elem.campaignType === CampaignType[CampaignType.SCHEDULED_CALL_BACK] ||
                  elem.campaignType === CampaignType[CampaignType.VISIO_SCHEDULED_CALL_BACK]
              ).map((toConvert: IAppointmentDto): IAppointment => Appointment.fromDto(toConvert))
            );
          } else {
            deferred.reject();
          }
        },
        () => deferred.reject()
      );
    return RxUtil.fromPromise(() => deferred.promise);
  }

  deleteAppointment(appointment: IAppointment): IPromise<any> {
    return this.$http.delete(this.configuration.campaignBaseUrl + '/protected/contact/' + appointment.idContact).then(() => {
      // send the event
      this.messaging.forLocal().publish(REFRESH_INPROCESS_INTERACTIONS, undefined);
    });
  }

  changeAppointment(appointment: IAppointment): IPromise<any> {
    return this.$http
      .put(`${this.configuration.campaignBaseUrl}/protected/contact/${appointment.idContact}/timeslot/${appointment.timeSlot.id}`, null)
      .then(() => {
        // send the event
        this.messaging.forLocal().publish(REFRESH_INPROCESS_INTERACTIONS, undefined);
      });
  }

  buildEmptyAppointment(): IPromise<IAppointment> {
    return this.buildAppointment(None, None, None, None);
  }

  buildAppointment(
    contactUriToUse: Option<string>,
    contactFirstNameToUse: Option<string>,
    contactLastNameToUse: Option<string>,
    skillsToPreselect: Option<string[]>
  ): IPromise<IAppointment> {
    let deferred = this.$q.defer<IAppointment>();

    let appointment = new Appointment();
    // call getSkills to populate availableSkills
    this.getSkills().then(
      () => {
        appointment.phone = contactUriToUse.getOrElse('');
        appointment.firstName = contactFirstNameToUse.getOrElse('');
        appointment.lastName = contactLastNameToUse.getOrElse('');

        appointment.idContact = randomUUID();

        skillsToPreselect.getOrElse([]).forEach((skillName: string) => {
          this.availableSkills
            .filter((currentAvailableSkill): boolean => skillName === currentAvailableSkill.name)
            .forEach(skillToPreselect => appointment.skillList.push(skillToPreselect));
        });
        deferred.resolve(appointment);
      },
      () => deferred.reject()
    );

    return deferred.promise;
  }

  openAppointmentForm(
    responseId?: string,
    contactUri?: string,
    contactFirstName?: string,
    contactLastName?: string,
    skillsToPreselect?: string[]
  ): void {
    this.$uibModal.open({
      component: 'appointmentPopup',
      keyboard: false,
      ariaLabelledBy: 'modal-header',
      ariaDescribedBy: 'modal-body',
      resolve: {
        // type of ModalParamAppointment
        mode: () => CREATE_MODE,
        responseId: () => responseId,
        contactUri: () => contactUri,
        contactFirstName: () => contactFirstName,
        contactLastName: () => contactLastName,
        skillsToPreselect: () => skillsToPreselect,
      },
    });
  }

  openAppointmentTransferForm(idAppointment: string, skillsToPreselect?: string[], interviewType?: InterviewType): Observable<void> {
    return Observable.create(subscriber => {
      this.$uibModal
        .open({
          component: 'appointmentTransferPopup',
          keyboard: false,
          ariaLabelledBy: 'modal-header',
          ariaDescribedBy: 'modal-body',
          resolve: {
            mode: () => interviewType?.toString() || '',
            idAppointment: () => idAppointment,
            skillsToPreselect: () => skillsToPreselect,
          },
        })
        .result.then(
          () => subscriber.complete(),
          () => subscriber.error()
        );
    });
  }

  openPostPoneAppointmentForm(appointment: IAppointment): Observable<void> {
    return Observable.create(subscriber => {
      this.$uibModal
        .open({
          component: 'appointmentPopup',
          keyboard: false,
          ariaLabelledBy: 'modal-header',
          ariaDescribedBy: 'modal-body',
          resolve: {
            // type of ModalParamAppointment
            mode: () => POST_PONE_MODE,
            appointment: () => appointment,
          },
        })
        .result.then(
          () => subscriber.complete(),
          () => subscriber.error()
        );
    });
  }

  openAppointmentFormForContact(
    contactId?: string,
    contactUri?: string,
    contactFirstName?: string,
    contactLastName?: string,
    skillsToPreselect?: string[]
  ) {
    this.$uibModal.open({
      component: 'appointmentPopup',
      keyboard: false,
      ariaLabelledBy: 'modal-header',
      ariaDescribedBy: 'modal-body',
      resolve: {
        // type of ModalParamAppointment
        mode: () => CREATE_MODE,
        contactId: () => contactId,
        contactUri: () => contactUri,
        contactFirstName: () => contactFirstName,
        contactLastName: () => contactLastName,
        skillsToPreselect: () => skillsToPreselect,
      },
    });
  }

  openAppointmentReschedulingForm(appointmentId: string, campaignId: string, originalTimeSlot: TimeSlot): void {
    this.$uibModal.open({
      component: 'appointmentRescheduling',
      keyboard: false,
      ariaLabelledBy: 'modal-header',
      ariaDescribedBy: 'modal-body',
      resolve: {
        // type of ModalParamAppointmentRescheduling
        appointmentId: () => appointmentId,
        campaignId: () => campaignId,
        originalTimeSlot: () => originalTimeSlot,
      },
    });
  }

  retrieveRescheduleTimesForDay(campaignId: string, day: Date): IPromise<number[]> {
    let deferred = this.$q.defer<number[]>();
    let qDate = moment(day).format('YYYY-MM-DD');

    this.$http
      .get(
        this.configuration.campaignBaseUrl +
          '/protected/campaign/getRescheduleDatesForADay/' +
          campaignId +
          '/15?day=' +
          qDate +
          '+00%3A00%3A00 '
      )
      .then(
        success => {
          if (success.data && isArray(success.data)) {
            deferred.resolve(success.data);
          }
        },
        () => {
          deferred.reject();
        }
      );

    return deferred.promise;
  }

  getOpenedTimeSlots(campaignUuid: string, endDate: Date | undefined): IPromise<TimeSlot[]> {
    let aBeginDate = moment().format('YYYY-MM-DDTHH:mm:ss').replace(/\:/g, '%3A');
    let anEndDate = endDate
      ? moment(endDate).format('YYYY-MM-DD') + 'T23%3A59%3A00'
      : moment().add(1, 'M').format('YYYY-MM-DD') + 'T23%3A59%3A00';
    let deferred = this.$q.defer<TimeSlot[]>();

    this.$http
      .get(
        this.configuration.campaignBaseUrl +
          '/protected/campaign/timeslots/' +
          campaignUuid +
          '?begin=' +
          aBeginDate +
          '&end=' +
          anEndDate +
          '&override=true'
      )
      .then(
        success => {
          if (success.data && isArray(success.data)) {
            deferred.resolve(success.data.map((timeslotDto: CCXMLTimeSlotDto): TimeSlot => TimeSlotUtil.fromDto(timeslotDto)));
          }
        },
        () => {
          deferred.reject();
        }
      );

    return deferred.promise;
  }

  closeAppointment(report: PostContactReportDto): IPromise<any> {
    let deferred = this.$q.defer<any>();

    // ODECSCNGACCEPTANCE-14306 - Dirty fix, waiting for ODECSCNGACCEPTANCE-14143
    // Anather report is send by MC on disconnectContact
    // This report must arrive after => setTimeout

    window.setTimeout(() => {
      this.$http.post(this.configuration.campaignBaseUrl + '/private/contact/' + report.idContact + '/report', report).then(
        () => {
          this.httpDeprecated
            .asPromise()
            .withData(Appointment.toDtoForTrace(report.appointment, report.action, report.origin, report.skillListUuid))
            .post(CSR_FACADE_PREFIX + '/addTraceUpdatedAppointment')
            .then(() => {
              return;
            });
          deferred.resolve();
        },
        () => deferred.reject()
      );
    }, 2000);

    return deferred.promise;
  }

  searchAppointmentsByContact(contactId: string, from = 0, size = 20, sortList = this.DEFAULT_SORT): Observable<IVisioAppointmentDetail[]> {
    const url = this.configuration.campaignBaseUrl + '/protected/search/search/' + this.sessionDeprecatedService.get() + '/appointment';
    let deferred = this.$q.defer<IVisioAppointmentDetail[]>();
    let searchParams: any = {
      sort: [],
      from: from,
      size: size,
      query: {
        bool: {
          must: [{ term: { 'idContact.keyword': contactId } }],
        },
      },
    };
    let sortField = {};
    sortList.forEach(sort => {
      sortField[sort.name] = { order: sort.order };
    });
    searchParams.sort.push(sortField);

    // do the request
    this.$log.debug('[appointment-service] do request searchAppointmentsByContact for contact[' + contactId + '] !');

    this.$http
      .post<any>(url, searchParams, {
        headers: {
          Accept: 'text/plain; charset=UTF-8',
          'Content-Type': 'text/plain; charset=UTF-8',
        },
      })
      .then(
        response => {
          if (response && response.data && isArray(response.data['hits']['hits'])) {
            deferred.resolve(response.data['hits']['hits'].map(toConvert => VisioAppointmentDetail.fromDto(toConvert['_source'])));
          } else {
            deferred.reject();
          }
        },
        () => deferred.reject()
      );
    return RxUtil.fromPromise(() => deferred.promise).pipe(
      tap(
        next => this.$log.debug(`[appointment-service] searchAppointmentsByContact found : [${JSON.stringify(next)}]`),
        error => this.$log.error(`[appointment-service] searchAppointmentsByContact failed : [${JSON.stringify(error)}]`),
        () => this.$log.debug(`[appointment-service] searchAppointmentsByContact done`)
      )
    );
  }

  searchAppointmentsById(appointmentId: string, from = 0, size = 20, sortList = this.DEFAULT_SORT): Observable<IVisioAppointmentDetail[]> {
    const url = this.configuration.campaignBaseUrl + '/protected/search/search/' + this.sessionDeprecatedService.get() + '/appointment';
    let deferred = this.$q.defer<IVisioAppointmentDetail[]>();
    let searchParams: any = {
      sort: [],
      from: from,
      size: size,
      query: {
        bool: {
          must: [
            // { "term": { "type.notAnalyzed": "APPOINTMENT"} },
            //  { "term": { "uuid.notAnalyzed": appointmentId} }
            { term: { 'type.keyword': 'APPOINTMENT' } },
            { term: { 'uuid.keyword': appointmentId } },
          ],
        },
      },
    };
    let sortField = {};
    sortList.forEach(sort => {
      sortField[sort.name] = { order: sort.order };
    });
    searchParams.sort.push(sortField);

    // do the request
    this.$log.debug('[appointment-service] do request searchAppointmentsById for contact[' + appointmentId + '] !');

    this.$http
      .post<any>(url, searchParams, {
        headers: {
          Accept: 'text/plain; charset=UTF-8',
          'Content-Type': 'text/plain; charset=UTF-8',
        },
      })
      .then(
        response => {
          if (response && response.data && isArray(response.data['hits']['hits'])) {
            deferred.resolve(response.data['hits']['hits'].map(toConvert => VisioAppointmentDetail.fromDto(toConvert['_source'])));
          } else {
            deferred.reject();
          }
        },
        () => deferred.reject()
      );
    return RxUtil.fromPromise(() => deferred.promise).pipe(
      tap(
        next => this.$log.debug(`[appointment-service] searchAppointmentsById found : [${JSON.stringify(next)}]`),
        error => this.$log.error(`[appointment-service] searchAppointmentsById failed : [${JSON.stringify(error)}]`),
        () => this.$log.debug(`[appointment-service] searchAppointmentsById done`)
      )
    );
  }

  private getSkillsForChannel(_channel: Channel): IPromise<Skill[]> {
    let deferred = this.$q.defer<Skill[]>();

    this.httpDeprecated
      .asPromise()
      .post(CSR_FACADE_PREFIX + '/getSkillsOfDomainForChannel', [_channel.type, _channel.direction])
      .then(
        (success: any) => {
          this.availableSkills = success.data.map(
            (skillDto): Skill => ({
              id: skillDto.uuid,
              name: skillDto.name,
            })
          );
          this.availableSkills = this.$filter('orderBy')(this.availableSkills, 'name', false);
          deferred.resolve(this.availableSkills);
        },
        () => {
          deferred.reject();
        }
      );

    return deferred.promise;
  }
}

export default 'appointmentDeprecatedService';
